import { JATOButtonIcon, JATOTheme } from '@jato/ui-component-library'
import { getTranslations } from 'redux/translations/translationsSlice'

import { ISpecsNavItemProps } from 'components/Specifications/SpecsNavigation/SpecsNavigation'
import React from 'react'
import { useAppSelector } from 'redux/hook'

export const SpecsAdvanceFilterNavItem: React.FC<ISpecsNavItemProps> = ({
  onChangeActive,
  isActive,
}: ISpecsNavItemProps) => {
  const translations = useAppSelector(getTranslations)

  return (
    <JATOButtonIcon
      id="specsAdvancedFilterButton"
      title={translations.JNT_AdvanceSearch}
      iconName="custom_filter"
      onClick={() => onChangeActive(!isActive)}
      iconFill={isActive ? JATOTheme.colors.primary : undefined}
    />
  )
}
